module.exports = __webpack_public_path__ + "static/media/ResJ1.05c4cac3.pdf";